import CoreUtils from '../../../utils/coreUtils.js';
import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import GeoUtils from '../geoUtils.js';
import RoundedBox from '../roundedBox.js';

const CHAMFER_OFFSET = 0.04;

export default class NodeCreateBox extends Node
{
	constructor(pParent)
	{
		super(pParent);
		
		this.addInput(PARAM_TYPE.FLOAT, 'width', 1, { units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'height', 1, { units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'depth', 1, { units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.INTEGER, 'box_subdivs', 0, { minValue: 0, maxValue: 10 });

		this.addInput(PARAM_TYPE.FLOAT, 'chamfer', 0.0, { minValue: 0, maxValue: 100, units: PARAM_UNITS.PERCENT });
		this.addInput(PARAM_TYPE.FLOAT, 'chamfer_meters', 0.01, { minValue: 0, maxValue: 0.2, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.BOOLEAN, 'use_absolute_chamfer_value', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'smooth', true);
		this.addInput(PARAM_TYPE.INTEGER, 'subdivisions', 3, { minValue: 1, maxValue: 10 });

		this.addInputsToGroup('Chamfer', ['chamfer', 'chamfer_meters', 'use_absolute_chamfer_value', 'smooth', 'subdivisions']);
		
		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');	
	}
	
	getType()
	{
		return 'box';
	}

	getIsInputEnabledSubclass(strInputName)
	{
		if(strInputName !== 'chamfer' && strInputName !== 'chamfer_meters')
			return true;

		const bUseAbsoluteValue = this.getLastInputResult('use_absolute_chamfer_value');
		return (bUseAbsoluteValue && strInputName === 'chamfer_meters') 
					|| (!bUseAbsoluteValue && strInputName === 'chamfer');
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		if(inputValues['width'] <= 0 || inputValues['width'] === Infinity
			|| inputValues['depth'] <= 0 || inputValues['depth'] === Infinity
			|| inputValues['height'] <= 0 || inputValues['height'] === Infinity)
		return null;

		let pBox;

		const useChamfer = inputValues['chamfer'] > 0.0 || (inputValues['chamfer_meters'] > 0.0 && inputValues['use_absolute_chamfer_value']);
		if(useChamfer)
		{
			const fMinDim = Math.min(inputValues['width'], inputValues['height'], inputValues['depth']);
			let fChamferValue;
			if(inputValues['use_absolute_chamfer_value'])
				fChamferValue = (2*inputValues['chamfer_meters'] + CHAMFER_OFFSET*fMinDim)/fMinDim;
			else 
			{
				const fPerc = CoreUtils.clamp(inputValues['chamfer']/100.0 - CHAMFER_OFFSET, 0, 1);
				fChamferValue = fMinDim*0.5*fPerc;
			}
				
			let roundedBox = new RoundedBox(inputValues['subdivisions'], 
					new BABYLON.Vector3(inputValues['width'], inputValues['height'], inputValues['depth']), fChamferValue);
			pBox = roundedBox.toMesh(this.getGeneratedMeshName(), scene);

			if(!inputValues['smooth'])
				pBox.convertToFlatShadedMesh();
		}
		else
		{
			pBox = BABYLON.MeshBuilder.CreateBox(this.getGeneratedMeshName(), { 
				width: inputValues['width'], 
				depth: inputValues['depth'], 
				height: inputValues['height'],
				sideOrientation: BABYLON.Mesh.FRONTSIDE,
				updatable: true
			}, scene);
		}

		//this.createAndAssignMaterial(pBox, scene, new BABYLON.Color3(255.0/255.0, 204/255, 0));
		GeoUtils.applyBoxUVsToMeshes([pBox]);

		if(inputValues['box_subdivs'] > 0)
			pBox.increaseVertices(inputValues['box_subdivs']);

		this.onMeshCreated(pBox);

		return [pBox];
	}
}
